import AxiosForm from '../../../model/form/AxiosForm';
import OrderFormBySteps from '../../../model/cart/order/order.module';
import { jOnHashAccordion, jOnOrderActiveTabs, setOrderHash } from '../../order';
import { replaceElModalRemoveCartForm } from '../../replace';
import { MobileStepStatement } from '../../../model/cart/order/plugin/MobileStepStatement';
import replaceInputFile from '../../replace/filepond';
import {
  feedbackStatement, maskDigitsOnly, validatePhones,
} from '../../validate';
import { WaCheckbox } from '../../../model/cart/order/plugin/WaCheckbox';
import { initAllMaps } from '../../../split/maps';
import { hideDeliveryInputsOnSelect } from '../../../model/cart/order/plugin/hideDeliveryInputsOnSelect';
import { updateManyProducts, updateProduct } from '../../cart/cart.update-product';
import initTags from '../../../middleware/yandex/yandex.init';

export function listenPreOrder() {
  const title = document.querySelector('.catalog-categories-block .title-h5');
  const getPreOrderForm = document.querySelector('.send-order');

  noHashOnRollBack();

  if (getPreOrderForm !== null) {
    getPreOrderForm.addEventListener('submit', async (event) => {
      const findPreOrderProducts = window.Dio.SHOP
        .CART.getAllProducts().findIndex(product => product.wish === true);
      // TODO: переделать инициализацию
      const hasPreOrderProducts = (findPreOrderProducts > -1);

      event.preventDefault();
      event.stopPropagation();

      feedbackStatement(getPreOrderForm.querySelector('.invalid-feedback'), false);

      if (hasPreOrderProducts) {
        await AxiosForm.getTemplate(
          {},
          getPreOrderForm,
          title,
          document.querySelector('.section-cart'),
        ).then(async () => {
          new OrderFormBySteps(
            document.querySelector('#order'),
            [
              MobileStepStatement,
              WaCheckbox,
              hideDeliveryInputsOnSelect,
            ],
            false,
          );
          validatePhones();
          maskDigitsOnly();
          setOrderHash();
          jOnOrderActiveTabs($('#order'));
          jOnHashAccordion($('#order'));
          listenFormCheck();
          const file = document.querySelector('#modal-search-by-photo-file');
          replaceInputFile(file);
          AxiosForm.showLoading(document.querySelector('.section-cart'), false);
          initAllMaps();
          initTags();
          window.scrollTo({
            top: document.querySelector('h1').offsetTop,
            behavior: 'smooth',
          });
        });
      } else {
        feedbackStatement(getPreOrderForm.querySelector('.invalid-feedback'), true);
      }
    });
  }
}

function noHashOnRollBack() {
  if (window.location.href.includes('cart#step')) {
    window.history.go(-1);
  }
}

export function listenNumberButtons() {
  const buttons = document.querySelectorAll('.custom-number-button');
  const numberInputs = document.querySelectorAll('.update-product-count-in-cart');

  Array.prototype.filter.call(buttons, (button) => {
    button.addEventListener('click', async (e) => {
      const productId = Number(e.target.closest('[data-cart-product-id]').dataset.cartProductId);
      const input = e.target.closest('button')?.parentElement.querySelector('input[type="number"]');

      if (e.target.closest('button')?.classList.contains('custom-number-increase')) {
        if (Number(input?.value) < Number(input?.max)) {
          input.value = Number(input.value) + 1;
        }
      } else if (Number(input?.value) > Number(input?.min)) {
        input.value = Number(input.value) - 1;
      }

      window.Dio.SHOP.CART_PREORDER.changeTotal(productId);
      window.Dio.SHOP.CART_WISHLIST.changeTotal(productId);

      updateProduct(productId);
    });
  });

  Array.prototype.filter.call(numberInputs, (Input) => {
    Input.addEventListener('change', (e) => {
      const productId = Number(e.target.closest('[data-cart-product-id]').dataset.cartProductId);

      window.Dio.SHOP.CART_PREORDER.changeTotal(productId);
      window.Dio.SHOP.CART_WISHLIST.changeTotal(productId);

      updateProduct(productId);
    });
  });
}

export function listenNumberInputs() {
  const Inputs = document.querySelectorAll('input[type="number"]');

  [...Inputs].forEach((Input) => {
    Input.addEventListener('click', function () {
      this.select();
    });
  });
}

export function listenRemoveButtons() {
  /**
   * @param {number} id
   */
  function removeFromCartAction(id) {
    id = Number(id);
    const CARD_REMOVE_URI = '/v1/cart/remove';
    const smCart = document.querySelector('.small-cart');

    /** @type {{ productId: number }} */
    const data = {
      productId: id,
    };

    window.axios
      .put(CARD_REMOVE_URI, data)
      /** @param {{ countItemsInCart: number }} response.data */
      .then((response) => {
        response.data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
        document.updateCartIcon(response.data?.countItemsInCart);
        if (window.Dio.SHOP.CART.getAllProductsCount() !== 1) {
          window.Dio.SHOP.CART_PREORDER.removeById(id);
          window.Dio.SHOP.CART_WISHLIST.removeById(id);
          fadeOutProduct(id);
        } else {
          window.location.reload();
        }
      })
      .catch((error) => {
        document.modalMessageErrorShow();
        // eslint-disable-next-line no-console
        console.warn(error);
      });
  }

  const buttons = document.querySelectorAll('[data-remove-select]');
  const removeFromCartButtons = document.querySelectorAll('[data-card-remove]');
  Array.prototype.filter.call(buttons, (button) => {
    button.addEventListener('click', (e) => {
      if (e.currentTarget.dataset?.removeSelect.length > 0) {
        document.querySelector(e.currentTarget.dataset.target)
          .dataset.productId = e.currentTarget.dataset?.removeSelect;
        replaceElModalRemoveCartForm(
          '<h3 class="modal-title title-h3" id="modalMessageLabel">Удаление товара</h3>',
          'Вы точно хотите <strong>удалить выбранный товар?</strong> <br>'
          + 'Отменить данное действие будет невозможно.',
        );
      }
    });
  });
}

export function listenRemoveSelectedProducts() {
  const button = document.querySelector('[data-remove-many]');

  if (button !== null) {
    button.onclick = (e) => {
      const modal = document.querySelector(e.currentTarget.dataset.target);
      modal.dataset.productId = '0';
      replaceElModalRemoveCartForm(
        '<h3 class="modal-title title-h3" id="modalMessageLabel">Удаление товаров</h3>',
        'Вы действительно хотите удалить <strong>выбранные товары</strong> из корзины? <br> Отменить данное действие будет невозможно.',
      );
    };
  }
}

/** ToggleClass parent checkbox */
export function listenFormCheck() {
  /** @type {NodeListOf<HTMLInputElement>} */
  const buttons = document.querySelectorAll('.form-option input[type="radio"]');
  Array.prototype.filter.call(buttons, (button) => {
    if (button.checked) button.closest('.form-option').classList.add('checked');
    button.onchange = (e) => {
      const parent = e.target.closest('.form-option').classList;
      const group = e.target.closest('.form-options-group');
      if (e.target.checked) {
        group?.querySelector('.form-option.checked')?.classList.remove('checked');
        parent.add('checked');
      }
    };
  });
}

export function listenBuyOneClick() {
  if (document.querySelector('#productId') !== null) {
    const button = document.querySelector('.product-fast-order');
    const smCart = document.querySelector('.small-cart');
    const wrap = smCart.closest('.modal-typography-container');

    if (button !== null) {
      button.onclick = (e) => {
        const buttonBuy = e.currentTarget.closest('.form-row').querySelector('.event-add-to-cart');
        const isSold = (buttonBuy === null)
          ? true
          : buttonBuy.closest('.btn-buy').classList.contains('btn-sold');

        AxiosForm.showLoading(wrap, true);

        if (!isSold) {
          buttonBuy?.click();
          buttonBuy.closest('.btn-buy').addEventListener('Cart:add', () => {
            getOneClickCartList();
          });
        } else {
          getOneClickCartList();
        }
      };
    }
  }
}

export function getOneClickCartList() {
  const smCart = document.querySelector('.small-cart');
  const wrap = smCart.closest('.modal-typography-container');
  const productId = Number(document.querySelector('#productId').value);
  const title = document.querySelector('#modalFastOrder .modal-title');
  const BUY_ONE_CLICK_URI = '/v1/cart/list-small';

  (async () => {
    await window.axios.get(BUY_ONE_CLICK_URI, { productId })
      .then((response) => {
        const [first] = response.data;
        if (smCart.closest('.small-cart-wrap') !== null) {
          smCart.closest('.small-cart-wrap').innerHTML = first;
          window.Dio.SHOP.CART
            .setProductsClassName('.small-cart-list [data-cart-product-id]');
          window.Dio.SHOP.CART.smCartListen();
        }
        AxiosForm.showLoading(wrap, false);
        const event = document.createEvent('Event');
        event.initEvent('SmCart:init', true, true);
        document.querySelector('.header-account-link').dispatchEvent(event);
      })
      .catch((error) => {
        console.log(error);
        AxiosForm.eventError(error, smCart, wrap, title);
        AxiosForm.showLoading(wrap, false);
      });

    // try {
    //
    // } catch (e) {
    //   throw new Error(`Cant load mini cart template${e}`);
    // }
  })();
}

export function listenPreOrderButton() {
  const buttons = document.querySelectorAll('.btn-pre-order');
  Array.prototype.filter.call(buttons, (button) => {
    button.onclick = (e) => {
      const el = e.currentTarget.querySelector('button');
      const modal = document.querySelector(el.dataset.target);
      modal.querySelector('input#order-items-product-id').value = Number(el.dataset.productId);
    };
  });
}

export function listenSelectedProducts() {
  const checkboxes = document.querySelectorAll('.cart-check-input');

  Array.prototype.filter.call(checkboxes, (checkbox) => {
    const product = checkbox.closest('[data-cart-product-id]');
    const productId = Number(product.dataset.cartProductId);

    checkbox.addEventListener('change', (event) => {
      const duplicateIndex = window.Dio.SHOP.CART_PREORDER.products
        .findIndex(oldProduct => productId === oldProduct.id);
      if (event.currentTarget.checked) {
        window.Dio.SHOP.CART_WISHLIST.removeById(productId);
        window.Dio.SHOP.CART_PREORDER.addByEl(product);
        if (duplicateIndex > -1) {
          window.Dio.SHOP.CART_PREORDER.removeById(productId);
        }
      } else {
        window.Dio.SHOP.CART_PREORDER.removeById(productId);
        window.Dio.SHOP.CART_WISHLIST.addByEl(product);
      }

      checkAllCheckboxUnchecked();
      updateProduct(productId);
    });
  });

  checkAllCheckboxUnchecked();
  listenAllProducts();
}

const checkAllCheckboxUnchecked = () => {
  const checkboxAll = document.querySelector('#select-all-products');
  const selectedProductsCount = document.querySelectorAll('[data-select-product]:checked').length;
  const productsCount = document.querySelectorAll('[data-select-product]').length;

  // use set timeout for next lifecycle
  if (checkboxAll !== null) {
    setTimeout(() => {
      if (selectedProductsCount === productsCount) {
        checkboxAll.checked = true;
      } else if (selectedProductsCount !== window.Dio.SHOP.CART.getAllProductsCount()) {
        checkboxAll.checked = false;
      }
    });
  }
};

/**
 *
 * @param {NodeList} checkboxes
 */
export function listenAllProducts() {
  /**
   * @type {HTMLElement}
   */
  const checkboxAll = document.querySelector('#select-all-products');
  checkboxAll?.addEventListener('change', (event) => {
    const beforeMutateProducts = window.Dio.SHOP.CART.getAllProducts();
    const checkedCount = document.querySelectorAll('.cart-check-input:checked').length;
    const checkboxes = document.querySelectorAll('.cart-check-input');

    if (event.currentTarget.checked) {
      Array.prototype.filter.call(checkboxes, (checkbox) => {
        const productId = Number(
          checkbox.closest('[data-cart-product-id]').dataset.cartProductId,
        );
        if (!checkbox.checked) {
          checkbox.checked = true;
          window.Dio.SHOP.CART_WISHLIST.removeById(productId);
          window.Dio.SHOP.CART_PREORDER.addByEl(checkbox.closest('[data-cart-product-id]'));
        }
      });
    } else {
      Array.prototype.filter.call(checkboxes, (checkbox) => {
        const productId = Number(
          checkbox.closest('[data-cart-product-id]').dataset.cartProductId,
        );
        if (checkbox.checked) {
          checkbox.checked = false;
          if (checkedCount !== 0) {
            window.Dio.SHOP.CART_PREORDER.removeById(productId);
            window.Dio.SHOP.CART_WISHLIST.addByEl(checkbox.closest('[data-cart-product-id]'));
          }
        }
      });
    }

    const afterMutateProducts = window.Dio.SHOP.CART.getAllProducts();
    const mutatedProducts = afterMutateProducts.filter(i => !beforeMutateProducts.includes(i));
    if (mutatedProducts.length > 0) {
      updateManyProducts(mutatedProducts);
    }
  });
}

export function listenBuyEventAndUpdateCartList() {
  const buttons = document.querySelectorAll('.btn-buy');
  const template = document.querySelector('.cart-block');

  if (template !== null) {
    Array.prototype.filter.call(buttons, (button) => {
      button.addEventListener('Cart:add', () => {
        AxiosForm.showLoading(template.parentElement, true);
        window.axios.get('v1/cart/list')
          .then(() => {
            window.location.reload();
          });
      });
    });
  }
}

export function listenFormWithCart() {
  const buttons = document.querySelectorAll('[data-send-products]');
  Array.prototype.filter.call(buttons, (button) => {
    button.onclick = async () => {
      const form = button.closest('form');
      form.querySelector('input[name="orderItems"]').value = JSON.stringify(window.Dio.SHOP.CART.getShortAllProducts());
    };
  });
}

// Отделить потом
function fadeOutProduct(productId) {
  const cartItem = $(`[data-cart-product-id=${productId}]`);
  cartItem.fadeOut(400, () => {
    cartItem.remove();
  });
}

export function fixOneClickMainProductRemove() {
  const btn = document.querySelector('#modalFastOrder .close');

  if (btn !== null) {
    btn.addEventListener('click', () => {
      const productId = Number(document.querySelector('#productId').value);
      const index = window.Dio.SHOP.CART.getShortAllProducts()
        .findIndex(product => product.product_id === productId);

      if (index === -1) {
        window.location.reload();
      }
    });
  }
}
